<template>
  <NormalRegister :image="image" v-if="findAttributeOnSiteInfo('registerType')[0] == 0" class="my-5"/>
  <RegisterWithVerifyCellPhone v-else :showPanels="showPanels" :defaultPanel="defaultPanel" :image="image"/>
</template>

<script>
import NormalRegister from "./NormalRegister";
import RegisterWithVerifyCellPhone from "./RegisterWithVerifyCellPhone";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

export default {
  name: "m-register-1",
  props: {
    image: {
      type: String,
      default: null
    },
    showPanels: {
      type: Boolean,
      default: false,
    },
    defaultPanel: {
      default: null,
    },
    showSiteRulesCheckbox:{
      type: Boolean,
      default: false,
    }
  },
  components: {NormalRegister, RegisterWithVerifyCellPhone},
  methods: {
    showToastAfterRedirectFomDashboard() {
      if (this.$route.name === 'Register') {
        toast(this.$t('authentication_general.authentication_message_if_user_not_login'), this.$t('authentication_general.authentication_message_if_user_not_login'), 'danger')
      }
    }
  },
  mounted() {
    this.showToastAfterRedirectFomDashboard()
    setSeoOnWrapper({},'register')
  }
}
</script>

<style scoped>

</style>